export type MetaData = {
  totalEntries: number
  currentPage: number
  perPage: number
}

export type OrderNotificationProps = {
  notification: Notification
  status: string
}

export type Notification = {
  id: number
  orderId: number
  appointmentDate?: string
  appointmentTime?: string
  signer: string
  classification: string
  subject: string
  readBy?: string
  readAt?: string
  text?: string
  createdAt: string
  notifiableId: number
  orderPath: string
  companyName?: string
  companyFaviconUrl?: string
  clientName: string
}

export type SortNotificationProps = {
  selectedValue: string
  handleChange: Function
}

export type NotificationReadByProps = {
  readBy: string
  readAt: string
}

export type NotificationIconProps = {
  classification: string
}

export type NotificationCreatedAtProps = {
  dateTime: string
}

export type MarkAsReadProps = {
  notification: Notification
  changeReadStatus: Function
}

export type AppointmentFullTimeProps = {
  date?: string
  time?: string
}

export type FormattedAppointmentFullTime = {
  text: string
  passed?: string
}

export type ForwardNotificationProps = {
  comment: Comment
  notification: Notification
  changeReadStatus: Function
  handleTooltipText: Function
}

export type StandardNotificationProps = {
  notification: Notification
  changeReadStatus: Function
}

export type CommentNotificationProps = {
  notification: Notification
  changeReadStatus: Function
}

export type Comment = {
  id: number
  clientName: string
  createdAt?: Date
  commenterAvatar: string
  commenterInitials: string
  commenterName: string
  commenterType: string
  hasBeenForwarded: boolean
  forwardable: boolean
  forwardedBy?: string
  text: string
  notaryName: string
  notificationSentToAgent: boolean
  notificationSentToClient: boolean
  forwardedToAgentAt?: Date
  forwardedToClientAt?: Date
  orderId: number
}

export type MarkAsReadBulkProps = {
  unreadCount: number
  source?: NotificationSourceFilter
}

export type MarkAsReadBulkContentProps = {
  unreadCount: number
  owner: string
  source?: NotificationSourceFilter
}

export type ClientAndCompanyNameProps = {
  notification: Notification
}

export type NotificationSourceFilter = 'all' | 'auto_pinner' | 'not_auto_pinner'

export const NotificationSourceFilterValues = {
  ALL: 'all' as const,
  AUTO_PINNER: 'auto_pinner' as const,
  NOT_AUTO_PINNER: 'not_auto_pinner' as const
}

export type SourceFilterDropdownProps = {
  autoPinnedCount: number
  notAutoPinnedCount: number
  selectedSource: NotificationSourceFilter
  onSourceChange: (source: NotificationSourceFilter) => void
}
